<template>
    <div class="component-box">
        <van-nav-bar
                :title="title"
                :left-text="leftText"
                :fixed="true"
                :left-arrow="showLeft"
                @click-left="handleClickLeft"
                @click-right="handleClickRight"
        >
            <van-icon v-if="showRight" name="search" slot="right"/>
        </van-nav-bar>
    </div>
</template>

<script>
    // 头部导航

    export default {
        name: "TheHeaderBar",
        props: {
            title: {
                type: String,
                required: true,
            },
            leftText: {
                type: String,
                default: ''
            },
            showLeft: {
                type: Boolean,
                default: true,
            },
            showRight: {
                type: Boolean,
                default: false,
            }
        },
        methods: {
            //点击左侧按钮
            handleClickLeft() {
                this.$router.go(-1);
            },

            //点击右侧按钮
            handleClickRight(){
                this.$emit('handleClickRight');
            },
        }
    }
</script>
<style>
    .van-nav-bar .van-icon{
        color: #00BFFF!important;
    }
    .van-nav-bar__title{
        font-size: 18px!important;
        font-weight: bold!important;
    }
</style>
<style scoped>

</style>